import React from 'react'
import { AddToTrolley } from '@sainsburys-tech/bolt'
import AddToTrolleyButtonWrapper from '../../AddToTrolleyButtonWrapper/AddToTrolleyButtonWrapper'
import FableAddToTrolleyButton from '../../FableAddToTrolleyButton/FableAddToTrolleyButton'

import * as Styled from './CollectionBox.styles'

const { Button: TrolleyButton } = AddToTrolley

export const ChangeStore = ({ openStoreSelector }) => (
  <a onClick={openStoreSelector} onKeyPress={openStoreSelector} role='link' tabIndex='0'>
    Change store
  </a>
)

const clickOrigin = 'PDP:collectionATT'

export const CollectionTrolleyButton = ({
  addToTrolley,
  collectionIcon,
  trolleyButtonOnErrorTracking,
  collectionStore,
  trolleyButtonTracking,
  openStoreSelector,
  partNumber,
  productList
}) => {
  const trackingParams = {
    clickOrigin,
    products: productList
  }

  return (
    <Styled.FulfilmentActionRow data-test='collection-store-CTA'>
      {/* PDP Hack: Change "cross" to "out_of_stock" as Basket yet to migrate to Bolt2 */}
      {collectionIcon !== 'out_of_stock' && (
        <AddToTrolleyButtonWrapper>
          <TrolleyButton
            onClick={event => addToTrolley(event, collectionStore, trolleyButtonTracking)}
            onError={trolleyButtonOnErrorTracking(clickOrigin)}
            partNumber={partNumber}
            superType='tiny'
            type='secondary'
            small
            openView
          />
          <FableAddToTrolleyButton
            productId={partNumber}
            quantity={1}
            small
            kind='secondary'
            trackingParams={trackingParams}
          />
        </AddToTrolleyButtonWrapper>
      )}
      <ChangeStore openStoreSelector={openStoreSelector} />
    </Styled.FulfilmentActionRow>
  )
}
